import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';

const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="datenschutz-page">
      <Navbar />
      <div className="hero-glow" />
      <main className="pt-20 relative">
        {/* Hero Section - Lebendiges Layout */}
        <section className="py-12 md:py-16 relative overflow-hidden">
          <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="max-w-3xl"
            >
              <span className="text-primary text-sm font-semibold uppercase tracking-widest mb-6 block">
                Rechtliches
              </span>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold tracking-tight leading-[1.1] mb-6" data-testid="datenschutz-headline">
                Datenschutzerklärung
              </h1>
              <p className="text-lg text-muted-foreground leading-relaxed max-w-xl">
                Informationen zum Umgang mit Ihren personenbezogenen Daten
              </p>
            </motion.div>
          </div>
        </section>

        {/* Content Section */}
        <section className="py-12 md:py-16 bg-[#0A0A0A]">
          <div className="max-w-4xl mx-auto px-6 md:px-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="flex flex-col gap-6"
            >
              <div className="bg-card/30 border border-white/10 rounded-2xl p-8">
                <h2 className="text-xl font-heading font-semibold text-white mb-4">1. Datenschutz auf einen Blick</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, 
                  wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert 
                  werden können.
                </p>
              </div>

              <div className="bg-card/30 border border-white/10 rounded-2xl p-8">
                <h2 className="text-xl font-heading font-semibold text-white mb-4">2. Datenerfassung auf dieser Website</h2>
                <div className="text-muted-foreground leading-relaxed space-y-4">
                  <p>
                    <span className="text-white font-medium">Wer ist verantwortlich für die Datenerfassung?</span><br />
                    Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können 
                    Sie dem Impressum dieser Website entnehmen.
                  </p>
                  <p>
                    <span className="text-white font-medium">Wie erfassen wir Ihre Daten?</span><br />
                    Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um 
                    Daten handeln, die Sie in ein Kontaktformular eingeben.
                  </p>
                  <p>
                    Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere 
                    IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder 
                    Uhrzeit des Seitenaufrufs).
                  </p>
                </div>
              </div>

              <div className="bg-card/30 border border-white/10 rounded-2xl p-8">
                <h2 className="text-xl font-heading font-semibold text-white mb-4">3. Ihre Rechte</h2>
                <div className="text-muted-foreground leading-relaxed space-y-4">
                  <p>
                    Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer 
                    gespeicherten personenbezogenen Daten zu erhalten.
                  </p>
                  <p>
                    Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie 
                    eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für 
                    die Zukunft widerrufen.
                  </p>
                  <p>
                    Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer 
                    personenbezogenen Daten zu verlangen.
                  </p>
                </div>
              </div>

              <div className="bg-card/30 border border-white/10 rounded-2xl p-8">
                <h2 className="text-xl font-heading font-semibold text-white mb-4">4. Kontaktformular</h2>
                <div className="text-muted-foreground leading-relaxed space-y-4">
                  <p>
                    Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem 
                    Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung 
                    der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
                  </p>
                  <p>
                    Diese Daten geben wir nicht ohne Ihre Einwilligung weiter. Die Verarbeitung dieser Daten 
                    erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung 
                    eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist.
                  </p>
                </div>
              </div>

              <div className="bg-card/30 border border-white/10 rounded-2xl p-8">
                <h2 className="text-xl font-heading font-semibold text-white mb-4">5. Hosting</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Unsere Website wird bei einem externen Dienstleister gehostet. Die personenbezogenen Daten, die auf 
                  dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich 
                  v.a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, 
                  Namen, Websitezugriffe und sonstige Daten, die über eine Website generiert werden, handeln.
                </p>
              </div>

              <div className="bg-card/30 border border-white/10 rounded-2xl p-8">
                <h2 className="text-xl font-heading font-semibold text-white mb-4">6. Kontakt bei Datenschutzfragen</h2>
                <div className="text-muted-foreground leading-relaxed">
                  <p className="mb-4">
                    Bei Fragen zur Erhebung, Verarbeitung oder Nutzung Ihrer personenbezogenen Daten, bei Auskünften, 
                    Berichtigung, Sperrung oder Löschung von Daten wenden Sie sich bitte an:
                  </p>
                  <p>
                    <span className="text-white">MEHRAZAV</span><br />
                    Maximilian Trost<br />
                    E-Mail: <a href="mailto:hey@mehrazav.de" className="text-primary hover:text-[#05b873] transition-colors">hey@mehrazav.de</a>
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </section>
      </main>
      <Footer />
      <div className="noise-overlay" />
    </div>
  );
};

export default Datenschutz;
